














































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import Button from "@/shared/components/ui/Button.vue";
import {
  AdvisorEventType,
  HsabSsoDestination,
} from "@/shared/types";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserAdvisorStore } from "@/shared/store/userAdvisor";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useTaxSavingsStore } from "@/shared/store/taxSavings";
import moment from "moment";

@Component({
  components: {
    SsoDeepLink,
    Button
  }
})
export default class TaxSavingsWidget extends Vue {
  partnerPortalStore = usePartnerPortalStore();
  custodianSettingsStore = useCustodianSettingsStore();
  advisorStore = useUserAdvisorStore();
  featureFlagStore = useFeatureFlagStore();
  taxSavingsStore = useTaxSavingsStore();

  formatCurrency = formatCurrency;

  mounted (): void {
    this.partnerPortalStore.getPartnerPortalStatus();
    this.custodianSettingsStore.getCustodianSettings();
    this.taxSavingsStore.load();
  }

  logEvent () {
    this.advisorStore.saveEvent(AdvisorEventType.SsoTaxLinkClick);
  }

  get taxSavings (): number {
    return this.taxSavingsStore.taxSavings(moment().year());
  }

  get hsabStatementsDeeplinkLocation () {
    return HsabSsoDestination.Statements;
  }

  get isLoaded () {
    return this.taxSavingsStore.isLoaded(moment().year());
  }
}
